import React from "react";
import { Flex, FlexProps } from "@chakra-ui/react";

export interface RowProps extends FlexProps {}

export function Row(props: RowProps) {
  return <Flex direction="row" {...props} />;
}
